<template>
    <div class="merck-intro">
        <img src="@/assets/images/zplab/intro1.jpg" alt="">
        <img src="@/assets/images/zplab/intro2.jpg" alt="">
    </div>
</template>

<script>
export default {
    // mounted() {
    //     this.$emit("isShowBack", true)
    // },
}
</script>

<style lang="scss">
.merck-intro {
    padding: 10px;
    img {
        width: 100%;
        height: auto;
        margin-bottom: 10px;
    }
}
</style>
